import React, { useState, useEffect } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import SubNav from './Common/SubNav';
import Footer from './Common/Footer';
import { alertAction } from '../Redux/Actions/alertAction';

const AddPkgGrp = ({ isShow, setIsShow }) => {
    const { slug } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const initialValues = { pkgGroup: '', status: '' };
    const [formValues, setFormValues] = useState(initialValues);
    const [formErrors, setFormErrors] = useState({});
    const [isSubmit, setIsSubmit] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormValues({ ...formValues, [name]: value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setFormErrors(validate(formValues));
        setIsSubmit(true);
        console.log(formValues);
    };

    useEffect(() => {
        if (Object.keys(formErrors).length === 0 && isSubmit) {
            navigate('/admin/programgrp/all');
            dispatch(alertAction())
            setIsSubmit(false);
        }
    }, [formErrors, isSubmit])


    const validate = (values) => {
        const errors = {};
        if (!values.status) {
            errors.status = "Status must be selected!"
        }
        if (!values.pkgGroup) {
            errors.pkgGroup = "This field is mandatory!"
        }
        return errors;
    };

    useEffect(() => {
        if (slug) {
            setFormValues({ pkgGroup: 'BuildUp', status: 'Active' })
        }
    }, [slug])


    return (
        <div className='page_first_div'>
            <SubNav isShow={isShow} setIsShow={setIsShow} />
            <div className='page_sec_div '>
                <p className='page_topic inline-block'>{`${slug ? "Edit" : "Add"} Package Groups`}</p>
                <div className='inline-block bg-cyan-600 px-3 py-1 ml-2 rounded-md hover:bg-cyan-700 animation'>
                    <Link to="/admin/programgrp/all" className='link block text-white text-sm'>
                        <i className="fa-solid fa-arrow-left mr-1"></i>
                        All
                    </Link>
                </div>
                <section className='page_section px-4 xsm:px-8 py-2 min-h-[14rem]'>
                    <form action="" onSubmit={handleSubmit}>
                        <div className='grid gap-4 lg:grid-cols-2 lg:gap-6 pt-10'>
                            <div className='font-lato text-sm xsm:text-base'>
                                <p className='text-gray-800 font-semibold tracking-wider'>Package Group<span className='text-red-500'>&#42;</span></p>
                                <input type="text" className='form_input border-2 h-10 w-full placeholder:text-xs xsm:placeholder:text-sm' placeholder='Please Provide Group Name' name='pkgGroup' value={formValues.pkgGroup} onChange={handleChange} />
                                <small className="text-red-500 tracking-wide">{formErrors.pkgGroup}</small>
                            </div>
                            <div className='font-lato '>
                                <p className='text-gray-800 font-semibold tracking-wider text-sm xsm:text-base'>Status<span className='text-red-500'>&#42;</span></p>
                                <select className="selector" name='status' value={formValues.status} onChange={handleChange}>
                                    <option value=''>--Select status--</option>
                                    <option value="Active" className=''>Active</option>
                                    <option value="Inactive">Inactive</option>
                                </select>
                                <small className="text-red-500 tracking-wide">{formErrors.status}</small>
                            </div>
                        </div>
                        <div className='pt-4 lg:pt-10'>
                            <button className='button mr-2' type='submit'>{`${slug ? "Update" : "Save"}`}</button>
                            <button className='button2' type='reset' onClick={() => setFormValues(initialValues)}>Reset</button>
                        </div>
                    </form>
                </section>
            </div>
            <Footer />
        </div>
    )
}

export default AddPkgGrp;